<template>
    <div class="info-buttons">
        <div v-if="displayContents(activeInfoButton, 'options')">
            <div class='custom-select c-button'>
                <div class="dropdown">
                    <div class="dropdown-toggle" type="button" id="drop-down-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Options
                    </div>
                    <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <b class="custom-caret">&nbsp;</b>
                    </div>
                    <div class="dropdown-menu" aria-labelledby="drop-down-menu">
                            <div>
                                <div v-on:click="print" class='custom-option'>Print</div>
                            </div>
                            <div>
                                <div v-on:click="saveAsPDF" class='custom-option'>Save as PDF</div>
                            </div>
                            <!-- changed to v-if as v-show was not reloading correctly -->
                            <!-- <div v-if="showCancel">
                                <div v-on:click="cancelRequest" class='custom-option'>Cancel Request</div>
                            </div>
                            -->
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="displayContents(activeInfoButton, 'cancel')">
            <div class='cancel-buttons'>
                <button @click.prevent="submitCancel" class="button is-cancel" v-bind:class="{ 'is-loading': cancelLoader }" :disabled="! canCancel">Submit Cancellation</button>
                <button @click.prevent="closeCancel"class="button v-button tertiary-button">Go Back</button>
            </div>
        </div>
        <div v-else-if="displayContents(activeInfoButton, 'new-request')">
            <div class='cancel-buttons'>
                <button @click.prevent="closeNewRequest"class="button v-button tertiary-button">Go Back</button>
                <button @click.prevent="submitNewRequest" class="button is-link" v-bind:class="{ 'is-loading': requestLoader }">Submit Request</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {

    computed: {

        ...mapState('nav', {
            activeRequestsTab: state => state.activeRequestsTab,
            activeRequestInfoTab: state => state.activeRequestInfoTab,
            activeInfoButton: state => state.activeInfoButton,
        }),

        ...mapState('cancelRequest', {
            cancelLoader: state => state.cancelLoader,
            canCancel: state => state.canCancel,
        }),
        
        ...mapGetters('requests', {
            showCancel: 'getShowCancelRequest'
        }),


    },

    methods: {
        displayContents(activeName, name) {
            return activeName === name;
        },

        submitNewRequest(){
            var clientType = VueStore.state.user.user.client_type_id;

            switch(clientType){
                // Medical client
                case 1:
                    VueStore.dispatch('newRequest/saveAllMedicalRequests');
                    //console.log("Medical")
                    break;
                // Education client
                case 2:
                    VueStore.dispatch('newRequest/saveAllEducationRequests');
                    //console.log("Education")
                    break;
            }
        },

        closeNewRequest(){
            VueStore.dispatch('newRequest/checkBeforeLeaving');
        },

        cancelRequest(){
            //VueStore.dispatch('cancelRequest/checkLastMinuteCancel');
            VueStore.dispatch('cancelRequest/setupCancellation');
            VueStore.dispatch('nav/setVariables', {key: 'scrollTop', value: true});
        },

        closeCancel(){
            VueStore.dispatch('cancelRequest/checkBeforeLeaving');
        },

        print(){
            VueStore.dispatch('exportRequest/openPrintableRequest');
        },

        saveAsPDF(){
            VueStore.dispatch('exportRequest/saveAsPDF');
        },

        submitCancel(){
            //VueStore.dispatch('cancelRequest/checkBeforeSubmitCancel');
            VueStore.dispatch('notify/setShowMessage', {key: 'showCancelRequestConfirm', bool: true});
        },
    }

}

</script>

<style>
</style>
